
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    const addedRoutes = router.getRoutes().filter(r => !r._initial)
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      for (const route of router.getRoutes()) {
        route._initial = true
      }
      for (const route of addedRoutes) {
        router.addRoute(route)
      }
      router.isReady().then(() => {
        // Resolve the current path against the new routes to get updated meta
        const newRoute = router.resolve(router.currentRoute.value.fullPath)
        // Clear old meta values and assign new ones
        for (const key of Object.keys(router.currentRoute.value.meta)) {
          delete router.currentRoute.value.meta[key]
        }
        Object.assign(router.currentRoute.value.meta, newRoute.meta)
      })
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
    for (const route of _router.getRoutes()) {
      route._initial = true
    }
  }
}
import { default as _91id_93P_9mOSybwCZtlmMrAbF1grZdrigdSIDppCQIQOoSi1oMeta } from "/home/node/app/shop/app/pages/shop/profile/loyalty-card/stickers/[id].vue?macro=true";
import { default as couponsuz9F5INjGZwUsFKF1KQU5Ouoz8qMHjYrY_KSly2DV0MMeta } from "/home/node/app/shop/app/pages/shop/profile/loyalty-card/coupons.vue?macro=true";
import { default as partner_45programS5DA1pKd2_VwPP71R9CSekLlikgRbgqHyfw5Wgcb1zgMeta } from "/home/node/app/shop/app/pages/shop/profile/loyalty-card/partner-program.vue?macro=true";
import { default as indexKEJgX8jleVqahGGRjcauCdXtvNw1I02hhtGVH1KgAPkMeta } from "/home/node/app/shop/app/pages/shop/profile/loyalty-card/stickers/index.vue?macro=true";
import { default as transactions3XCuUfpikpObXOw_Ot9nOCaMPrMv4m89MA_uxYNL2FsMeta } from "/home/node/app/shop/app/pages/shop/profile/loyalty-card/transactions.vue?macro=true";
import { default as _91hash_93suA0qePQKDbtU56kmHR1II_qdb_Yk_8maqgPclELP_gMeta } from "/home/node/app/shop/app/pages/admin/cms/content_preview/[hash].vue?macro=true";
import { default as indexjiCG2GCfC3m1f_IXetdt9noUECHeiHOKM8UGXyG8BVAMeta } from "/home/node/app/shop/app/pages/shop/profile/billing-addresses/index.vue?macro=true";
import { default as indexTd_seibt3nkU2sWo1DLSQbHug13N8fTwopDBkqM16_gMeta } from "/home/node/app/shop/app/pages/shop/profile/cards/index.vue?macro=true";
import { default as indexdynRkLQ_GqxBmrLNc48AKj985PQHOTaeyLT_0h7P9S0Meta } from "/home/node/app/shop/app/pages/shop/profile/data/index.vue?macro=true";
import { default as indexR7nOcMQ6TB7L8ajSOXTVzUDsXBqHDq590oH3UCBEeRkMeta } from "/home/node/app/shop/app/pages/shop/profile/delivery-addresses/index.vue?macro=true";
import { default as indexHMHx0yxE7X5vzCpDtidydUggooIRwpOiYWtXfTZjPbAMeta } from "/home/node/app/shop/app/pages/shop/profile/loyalty-card/index.vue?macro=true";
import { default as indexUtMCKUK1Xw3JnjB0s9YiK3o0GlTDm_KJmZrSu1_hFj8Meta } from "/home/node/app/shop/app/pages/shop/profile/loyalty-program/index.vue?macro=true";
import { default as indexfazg7zdmQSH0AzNrEVTwGszZ35arZ0RFK1bAHkMohIoMeta } from "/home/node/app/shop/app/pages/shop/profile/mailing-addresses/index.vue?macro=true";
import { default as indexujZvYGZQaw33QGZcq1zXK3foyOJ4zj9ukiulLUUueaUMeta } from "/home/node/app/shop/app/pages/shop/profile/manage/index.vue?macro=true";
import { default as index7uivxQ_nZLGy2ndQ8H67VwHsgURet5uJ1NwB9AYoOzIMeta } from "/home/node/app/shop/app/pages/shop/profile/order-again/index.vue?macro=true";
import { default as indexogjRPl9Ae_uMHZVHQBXh6q2byGTLLTMrQgRuB3k3Gm0Meta } from "/home/node/app/shop/app/pages/shop/profile/orders/index.vue?macro=true";
import { default as indexdWTicV6_o8s22R3aljapGkXz_QTxu46f9Mu4zKFx3mYMeta } from "/home/node/app/shop/app/pages/shop/profile/saved-baskets/index.vue?macro=true";
import { default as indexXNdO856TIGf3it8nElwhs41PcvOX_jLNc_jEdou9spIMeta } from "/home/node/app/shop/app/pages/simple/gift/back/index.vue?macro=true";
import { default as _91status_930yJcoSAAcuPeOJOLhtkxE_WYYLoQdIcBPC_wBFe3pisMeta } from "/home/node/app/shop/app/pages/cetelem/back/[order_ident]/[status].vue?macro=true";
import { default as _91hash_93yEIL0g1oUaGGwyYyCyruQAaCPvvECcpPPCe_k_23ijoMeta } from "/home/node/app/shop/app/pages/karrier/allas/[slug].j-[id]/[hash].vue?macro=true";
import { default as _91applicationGuid_93EEhH8J4OYnr8WmW_d87zwgGle2fWQbe8mFuaghk9fxMMeta } from "/home/node/app/shop/app/pages/karrier/ajanlatok/[applicationGuid].vue?macro=true";
import { default as indexuiqKSzpiaJWoEODXqRCJ8CHArU9uIKRxPEwLph8oy9IMeta } from "/home/node/app/shop/app/pages/karrier/allas/[slug].j-[id]/index.vue?macro=true";
import { default as _91orderIdent_937QyNdkUQ1dE4EjkXrEyutoQNdtN9Y7LFoo6Yf6WEZ2oMeta } from "/home/node/app/shop/app/pages/shop/checkout-success/[orderIdent].vue?macro=true";
import { default as _91type_93F_QyMU_D09KY1JiMkrkx66EyzIJC1ST51KKfzAJRypAMeta } from "/home/node/app/shop/app/pages/shop/checkout/[type].vue?macro=true";
import { default as _91list_name_93qjBtqlGTA6kb9PsSnt30l4Ly6IxQ8CdmwXihEM6SaywMeta } from "/home/node/app/shop/app/pages/shop/list/[list_name].vue?macro=true";
import { default as indexlqTbs2ueCymVrevLMjbh6lE04jkGc9Yb1kQ3s83SBegMeta } from "/home/node/app/shop/app/pages/cetelem/back/index.vue?macro=true";
import { default as indexwnXmKY4GSWJPF_UjxAJxz9SGtR1HSQu6GX3NQavEx_oMeta } from "/home/node/app/shop/app/pages/karrier/hirek/index.vue?macro=true";
import { default as SalesforceDHeWUHhjl_w2shTKFMafpchVNfamZKM_qsKS1SuAjHQMeta } from "/home/node/app/shop/app/pages/login/Salesforce.vue?macro=true";
import { default as indexGlRh3_FJGeHYrQMbVnQQ5WDoBf_t8sR_iIv54DP4aWMMeta } from "/home/node/app/shop/app/pages/loyalty-program/faq/index.vue?macro=true";
import { default as indexXXXpBduP5QZU3Ym3ivwVdhGQ06hLFlLkDY5PLJHr_R0Meta } from "/home/node/app/shop/app/pages/otp/back/index.vue?macro=true";
import { default as indexNLYSWNur2_Fo7fxCcZ8QxzcNsBsdVXmtjicf9INbnh0Meta } from "/home/node/app/shop/app/pages/petrol/faq/index.vue?macro=true";
import { default as indexf8MFGYY98zUistBLtQ1uG57AaxcH9r04_cEkGn_DoBYMeta } from "/home/node/app/shop/app/pages/shop/basket/index.vue?macro=true";
import { default as indexC99XDZBQSfl0EzFtaEDET83PygYgtV0L0KAi_ThwsjQMeta } from "/home/node/app/shop/app/pages/shop/compare/index.vue?macro=true";
import { default as indexZIiN52xkEf7SVkhFrDWOgouQq_J7YfStUAiRe3E8Jt8Meta } from "/home/node/app/shop/app/pages/shop/loyalty-offers/index.vue?macro=true";
import { default as indexv4Gr6UOb5OghoRJGbE4my96e8_ZU_UfRq4kMfo_iSY8Meta } from "/home/node/app/shop/app/pages/simple/back/index.vue?macro=true";
import { default as indexcQ63YFIqgZshvspSroIbYs5uoy9vMMsgWSS0pOaJccUMeta } from "/home/node/app/shop/app/pages/test/recon/index.vue?macro=true";
import { default as _91slug_93gEdkP__NKFkKyLcB0TwIU4DvQbsVxAaOToKUhAQfI1IMeta } from "/home/node/app/shop/app/pages/news/[type]/[slug].vue?macro=true";
import { default as _91hash_93Y94uoQ8x8bQyLbBMy5OS2P8hxD4vMjPkJoP_C9PgZWkMeta } from "/home/node/app/shop/app/pages/activate_registration/[hash].vue?macro=true";
import { default as _91hash_93VQ5CulCQrRKMba9o2O4TqCac1acOpC3CevAWxc_ctCkMeta } from "/home/node/app/shop/app/pages/career_password_change/[hash].vue?macro=true";
import { default as _91id_93QmrYkr8AW4uQyxwrgTJ_IwuyY_G12cg1nvWFp8lGTdwMeta } from "/home/node/app/shop/app/pages/content/[id].vue?macro=true";
import { default as _91orderIdent_93v5UyRcxdyOivodbDgYOD8_2TC1m8IYmn8L5SDhBm8lUMeta } from "/home/node/app/shop/app/pages/gift-card-order-success/[orderIdent].vue?macro=true";
import { default as _91hash_93zyrCi5_zfvudkSKA_KSPiCkvRCjoU0dhrYGLQWa_UH0Meta } from "/home/node/app/shop/app/pages/password_change/[hash].vue?macro=true";
import { default as _91slug_939y55sL0YNVIb_p9MqSMu2MhktqSyW6lwxft2Kv162voMeta } from "/home/node/app/shop/app/pages/petrol/[slug].vue?macro=true";
import { default as _91id_93AdUWjAnt_eaOwuvHhHgqeTIxJDvIbl3qXsmI6d_U7b0Meta } from "/home/node/app/shop/app/pages/product-list/[id].vue?macro=true";
import { default as _91id_93QrKbdUKvshruZmtu__zZhxqTsQTBJ6GAclL6KFZwuzUMeta } from "/home/node/app/shop/app/pages/product/[id].vue?macro=true";
import { default as _91slug_93iQVXuwL8ayKAAUYpHSb0IA0ZwHU0UWwM_ZMHFQ2NRy8Meta } from "/home/node/app/shop/app/pages/stores/[slug].vue?macro=true";
import { default as _91hash_93kMSoAaFt3RzNDGwzZToLDqQ9gveIl1WZ_v0XdI9FywMMeta } from "/home/node/app/shop/app/pages/user_email_update/[hash].vue?macro=true";
import { default as indexNkRI716QfI18jgkUfv5cVtyXIEn_TDft9unD3kh18MAMeta } from "/home/node/app/shop/app/pages/ajandekkartya-igenyles/index.vue?macro=true";
import { default as index2Yxux4s_smuRhUbW4zZ4HrM9tZp7MTjY_Se01Q_FQUMMeta } from "/home/node/app/shop/app/pages/catalog/index.vue?macro=true";
import { default as indexz79kCq2TkpT5bZuwiwhOMDKGPuQsiCxVwdWwoldF_BYMeta } from "/home/node/app/shop/app/pages/csr/index.vue?macro=true";
import { default as indexStrdWRNtV5jJ1wYajuuXB_iCJwCGgMjVXQvfBmgG3_kMeta } from "/home/node/app/shop/app/pages/faq/index.vue?macro=true";
import { default as indexPNK_cA0d_ybtlPI1CDynedCtomMvDWWqYt00ddy_LkUMeta } from "/home/node/app/shop/app/pages/food-delivery-map/index.vue?macro=true";
import { default as indexKcrVaCr1XHHoTS56GCmlKGbZeZAAnIsRMsgVl185cMUMeta } from "/home/node/app/shop/app/pages/forgotten-password/index.vue?macro=true";
import { default as index2LPWuPSJF9gAF4ibQoRq5L2HhtgByI3B0eeXqVCe6qIMeta } from "/home/node/app/shop/app/pages/inspirations/index.vue?macro=true";
import { default as index1ezYsO6zNgz0X5y9EmmVV_aEoWpsQhEY4UHTF_xAjzoMeta } from "/home/node/app/shop/app/pages/news/index.vue?macro=true";
import { default as indexYGj_6tL1Fde_fgvDJcuWKQuRhNOEfWZx_OzhylPa_hEMeta } from "/home/node/app/shop/app/pages/payment-redirect/index.vue?macro=true";
import { default as indexVTY2UoKdOlWzWMoBJ2S4JZ5nZIniUUQJWOgOX3t9RpwMeta } from "/home/node/app/shop/app/pages/press/index.vue?macro=true";
import { default as indexZQ8IH_GoF_dQnT8gfxvm4MFo_0_UXtRfD_XsO7kN2oIMeta } from "/home/node/app/shop/app/pages/prize-game/index.vue?macro=true";
import { default as index8FM2v9IdOH7DI5ttPfFGXg6iZMvgI_IstrMOtc3fHbgMeta } from "/home/node/app/shop/app/pages/safety-data-sheet/index.vue?macro=true";
import { default as indexgMcUrF09WinEJU8FBiRv63JZUiPpcbxrARZLLn76ktYMeta } from "/home/node/app/shop/app/pages/shop/index.vue?macro=true";
import { default as indexy2rZxuUoEL0zG7joIoZ1h6BRzpl0sEhfo8x_PCPG6gsMeta } from "/home/node/app/shop/app/pages/stores/index.vue?macro=true";
import { default as indexNEKKdxPoLbyofBYuIzvwtmmWBvNzxbTAN7y4jq5t0ZIMeta } from "/home/node/app/shop/app/pages/unsubscribe/index.vue?macro=true";
import { default as _91_46_46_46slug_93mA4XAdFsBtxO1eJKcnDotAmGqzTBJBPjaC2Cv2ah5u8Meta } from "/home/node/app/shop/app/pages/[...slug].vue?macro=true";
import { default as index_nPP1dj__PIFTxc6OCIouqT4ytO_ccsYURnU_7_rCl0Meta } from "/home/node/app/shop/app/pages/index.vue?macro=true";
import { default as component_45stubEfxyiN_x6Y8wD0QhzHCU33g2TBS2HdmakVxbMdrPi7gMeta } from "/home/node/app/node_modules/nuxt/dist/pages/runtime/component-stub.js?macro=true";
import { default as component_45stubEfxyiN_x6Y8wD0QhzHCU33g2TBS2HdmakVxbMdrPi7g } from "/home/node/app/node_modules/nuxt/dist/pages/runtime/component-stub.js";
export default [
  {
    name: "shop-profile-loyalty-card-stickers-id___hu",
    path: "/shop/profilom/bizalomkartyam/matricaim/:id()",
    meta: _91id_93P_9mOSybwCZtlmMrAbF1grZdrigdSIDppCQIQOoSi1oMeta || {},
    component: () => import("/home/node/app/shop/app/pages/shop/profile/loyalty-card/stickers/[id].vue")
  },
  {
    name: "shop-profile-loyalty-card-stickers-id___en",
    path: "/en/shop/profile/loyalty-card/stickers/:id()",
    meta: _91id_93P_9mOSybwCZtlmMrAbF1grZdrigdSIDppCQIQOoSi1oMeta || {},
    component: () => import("/home/node/app/shop/app/pages/shop/profile/loyalty-card/stickers/[id].vue")
  },
  {
    name: "shop-profile-loyalty-card-coupons___hu",
    path: "/shop/profilom/bizalomkartyam/kuponjaim",
    meta: couponsuz9F5INjGZwUsFKF1KQU5Ouoz8qMHjYrY_KSly2DV0MMeta || {},
    component: () => import("/home/node/app/shop/app/pages/shop/profile/loyalty-card/coupons.vue")
  },
  {
    name: "shop-profile-loyalty-card-coupons___en",
    path: "/en/shop/profile/loyalty-card/coupons",
    meta: couponsuz9F5INjGZwUsFKF1KQU5Ouoz8qMHjYrY_KSly2DV0MMeta || {},
    component: () => import("/home/node/app/shop/app/pages/shop/profile/loyalty-card/coupons.vue")
  },
  {
    name: "shop-profile-loyalty-card-partner-program___hu",
    path: "/shop/profilom/bizalomkartyam/partner-program",
    meta: partner_45programS5DA1pKd2_VwPP71R9CSekLlikgRbgqHyfw5Wgcb1zgMeta || {},
    component: () => import("/home/node/app/shop/app/pages/shop/profile/loyalty-card/partner-program.vue")
  },
  {
    name: "shop-profile-loyalty-card-partner-program___en",
    path: "/en/shop/profile/loyalty-card/partner-program",
    meta: partner_45programS5DA1pKd2_VwPP71R9CSekLlikgRbgqHyfw5Wgcb1zgMeta || {},
    component: () => import("/home/node/app/shop/app/pages/shop/profile/loyalty-card/partner-program.vue")
  },
  {
    name: "shop-profile-loyalty-card-stickers___hu",
    path: "/shop/profilom/bizalomkartyam/matricaim",
    meta: indexKEJgX8jleVqahGGRjcauCdXtvNw1I02hhtGVH1KgAPkMeta || {},
    component: () => import("/home/node/app/shop/app/pages/shop/profile/loyalty-card/stickers/index.vue")
  },
  {
    name: "shop-profile-loyalty-card-stickers___en",
    path: "/en/shop/profile/loyalty-card/stickers",
    meta: indexKEJgX8jleVqahGGRjcauCdXtvNw1I02hhtGVH1KgAPkMeta || {},
    component: () => import("/home/node/app/shop/app/pages/shop/profile/loyalty-card/stickers/index.vue")
  },
  {
    name: "shop-profile-loyalty-card-transactions___hu",
    path: "/shop/profilom/bizalomkartyam/korabbi-vasarlasaim",
    meta: transactions3XCuUfpikpObXOw_Ot9nOCaMPrMv4m89MA_uxYNL2FsMeta || {},
    component: () => import("/home/node/app/shop/app/pages/shop/profile/loyalty-card/transactions.vue")
  },
  {
    name: "shop-profile-loyalty-card-transactions___en",
    path: "/en/shop/profile/loyalty-card/transactions",
    meta: transactions3XCuUfpikpObXOw_Ot9nOCaMPrMv4m89MA_uxYNL2FsMeta || {},
    component: () => import("/home/node/app/shop/app/pages/shop/profile/loyalty-card/transactions.vue")
  },
  {
    name: "admin-cms-content_preview-hash___hu",
    path: "/admin/cms/content_preview/:hash()",
    meta: _91hash_93suA0qePQKDbtU56kmHR1II_qdb_Yk_8maqgPclELP_gMeta || {},
    component: () => import("/home/node/app/shop/app/pages/admin/cms/content_preview/[hash].vue")
  },
  {
    name: "admin-cms-content_preview-hash___en",
    path: "/en/admin/cms/content_preview/:hash()",
    meta: _91hash_93suA0qePQKDbtU56kmHR1II_qdb_Yk_8maqgPclELP_gMeta || {},
    component: () => import("/home/node/app/shop/app/pages/admin/cms/content_preview/[hash].vue")
  },
  {
    name: "shop-profile-billing-addresses___hu",
    path: "/shop/profilom/billing-addresses",
    meta: indexjiCG2GCfC3m1f_IXetdt9noUECHeiHOKM8UGXyG8BVAMeta || {},
    component: () => import("/home/node/app/shop/app/pages/shop/profile/billing-addresses/index.vue")
  },
  {
    name: "shop-profile-billing-addresses___en",
    path: "/en/shop/profile/billing-addresses",
    meta: indexjiCG2GCfC3m1f_IXetdt9noUECHeiHOKM8UGXyG8BVAMeta || {},
    component: () => import("/home/node/app/shop/app/pages/shop/profile/billing-addresses/index.vue")
  },
  {
    name: "shop-profile-cards___hu",
    path: "/shop/profilom/cards",
    meta: indexTd_seibt3nkU2sWo1DLSQbHug13N8fTwopDBkqM16_gMeta || {},
    component: () => import("/home/node/app/shop/app/pages/shop/profile/cards/index.vue")
  },
  {
    name: "shop-profile-cards___en",
    path: "/en/shop/profile/cards",
    meta: indexTd_seibt3nkU2sWo1DLSQbHug13N8fTwopDBkqM16_gMeta || {},
    component: () => import("/home/node/app/shop/app/pages/shop/profile/cards/index.vue")
  },
  {
    name: "shop-profile-data___hu",
    path: "/shop/profilom/data",
    meta: indexdynRkLQ_GqxBmrLNc48AKj985PQHOTaeyLT_0h7P9S0Meta || {},
    component: () => import("/home/node/app/shop/app/pages/shop/profile/data/index.vue")
  },
  {
    name: "shop-profile-data___en",
    path: "/en/shop/profile/data",
    meta: indexdynRkLQ_GqxBmrLNc48AKj985PQHOTaeyLT_0h7P9S0Meta || {},
    component: () => import("/home/node/app/shop/app/pages/shop/profile/data/index.vue")
  },
  {
    name: "shop-profile-delivery-addresses___hu",
    path: "/shop/profilom/delivery-addresses",
    meta: indexR7nOcMQ6TB7L8ajSOXTVzUDsXBqHDq590oH3UCBEeRkMeta || {},
    component: () => import("/home/node/app/shop/app/pages/shop/profile/delivery-addresses/index.vue")
  },
  {
    name: "shop-profile-delivery-addresses___en",
    path: "/en/shop/profile/delivery-addresses",
    meta: indexR7nOcMQ6TB7L8ajSOXTVzUDsXBqHDq590oH3UCBEeRkMeta || {},
    component: () => import("/home/node/app/shop/app/pages/shop/profile/delivery-addresses/index.vue")
  },
  {
    name: "shop-profile-loyalty-card___hu",
    path: "/shop/profilom/bizalomkartyam",
    meta: indexHMHx0yxE7X5vzCpDtidydUggooIRwpOiYWtXfTZjPbAMeta || {},
    component: () => import("/home/node/app/shop/app/pages/shop/profile/loyalty-card/index.vue")
  },
  {
    name: "shop-profile-loyalty-card___en",
    path: "/en/shop/profile/loyalty-card",
    meta: indexHMHx0yxE7X5vzCpDtidydUggooIRwpOiYWtXfTZjPbAMeta || {},
    component: () => import("/home/node/app/shop/app/pages/shop/profile/loyalty-card/index.vue")
  },
  {
    name: "shop-profile-loyalty-program___hu",
    path: "/shop/profilom/bizalomprogram",
    meta: indexUtMCKUK1Xw3JnjB0s9YiK3o0GlTDm_KJmZrSu1_hFj8Meta || {},
    component: () => import("/home/node/app/shop/app/pages/shop/profile/loyalty-program/index.vue")
  },
  {
    name: "shop-profile-loyalty-program___en",
    path: "/en/shop/profile/loyalty-program",
    meta: indexUtMCKUK1Xw3JnjB0s9YiK3o0GlTDm_KJmZrSu1_hFj8Meta || {},
    component: () => import("/home/node/app/shop/app/pages/shop/profile/loyalty-program/index.vue")
  },
  {
    name: "shop-profile-mailing-addresses___hu",
    path: "/shop/profilom/mailing-addresses",
    meta: indexfazg7zdmQSH0AzNrEVTwGszZ35arZ0RFK1bAHkMohIoMeta || {},
    component: () => import("/home/node/app/shop/app/pages/shop/profile/mailing-addresses/index.vue")
  },
  {
    name: "shop-profile-mailing-addresses___en",
    path: "/en/shop/profile/mailing-addresses",
    meta: indexfazg7zdmQSH0AzNrEVTwGszZ35arZ0RFK1bAHkMohIoMeta || {},
    component: () => import("/home/node/app/shop/app/pages/shop/profile/mailing-addresses/index.vue")
  },
  {
    name: "shop-profile-manage___hu",
    path: "/shop/profilom/manage",
    meta: indexujZvYGZQaw33QGZcq1zXK3foyOJ4zj9ukiulLUUueaUMeta || {},
    component: () => import("/home/node/app/shop/app/pages/shop/profile/manage/index.vue")
  },
  {
    name: "shop-profile-manage___en",
    path: "/en/shop/profile/manage",
    meta: indexujZvYGZQaw33QGZcq1zXK3foyOJ4zj9ukiulLUUueaUMeta || {},
    component: () => import("/home/node/app/shop/app/pages/shop/profile/manage/index.vue")
  },
  {
    name: "shop-profile-order-again___hu",
    path: "/shop/profilom/gyakori-termekek",
    meta: index7uivxQ_nZLGy2ndQ8H67VwHsgURet5uJ1NwB9AYoOzIMeta || {},
    component: () => import("/home/node/app/shop/app/pages/shop/profile/order-again/index.vue")
  },
  {
    name: "shop-profile-order-again___en",
    path: "/en/shop/profile/order-again",
    meta: index7uivxQ_nZLGy2ndQ8H67VwHsgURet5uJ1NwB9AYoOzIMeta || {},
    component: () => import("/home/node/app/shop/app/pages/shop/profile/order-again/index.vue")
  },
  {
    name: "shop-profile-orders___hu",
    path: "/shop/profilom/korabbi-rendeleseim",
    meta: indexogjRPl9Ae_uMHZVHQBXh6q2byGTLLTMrQgRuB3k3Gm0Meta || {},
    component: () => import("/home/node/app/shop/app/pages/shop/profile/orders/index.vue")
  },
  {
    name: "shop-profile-orders___en",
    path: "/en/shop/profile/orders",
    meta: indexogjRPl9Ae_uMHZVHQBXh6q2byGTLLTMrQgRuB3k3Gm0Meta || {},
    component: () => import("/home/node/app/shop/app/pages/shop/profile/orders/index.vue")
  },
  {
    name: "shop-profile-saved-baskets___hu",
    path: "/shop/profilom/bevasarlo-listaim",
    meta: indexdWTicV6_o8s22R3aljapGkXz_QTxu46f9Mu4zKFx3mYMeta || {},
    component: () => import("/home/node/app/shop/app/pages/shop/profile/saved-baskets/index.vue")
  },
  {
    name: "shop-profile-saved-baskets___en",
    path: "/en/shop/profile/saved-baskets",
    meta: indexdWTicV6_o8s22R3aljapGkXz_QTxu46f9Mu4zKFx3mYMeta || {},
    component: () => import("/home/node/app/shop/app/pages/shop/profile/saved-baskets/index.vue")
  },
  {
    name: "simple-gift-back___hu",
    path: "/simple/gift/back",
    component: () => import("/home/node/app/shop/app/pages/simple/gift/back/index.vue")
  },
  {
    name: "simple-gift-back___en",
    path: "/en/simple/gift/back",
    component: () => import("/home/node/app/shop/app/pages/simple/gift/back/index.vue")
  },
  {
    name: "cetelem-back-order_ident-status___hu",
    path: "/cetelem/back/:order_ident()/:status()",
    component: () => import("/home/node/app/shop/app/pages/cetelem/back/[order_ident]/[status].vue")
  },
  {
    name: "cetelem-back-order_ident-status___en",
    path: "/en/cetelem/back/:order_ident()/:status()",
    component: () => import("/home/node/app/shop/app/pages/cetelem/back/[order_ident]/[status].vue")
  },
  {
    name: "karrier-allas-slug.j-id-hash___hu",
    path: "/karrier/allas/:slug().j-:id()/:hash()",
    meta: _91hash_93yEIL0g1oUaGGwyYyCyruQAaCPvvECcpPPCe_k_23ijoMeta || {},
    component: () => import("/home/node/app/shop/app/pages/karrier/allas/[slug].j-[id]/[hash].vue")
  },
  {
    name: "karrier-allas-slug.j-id-hash___en",
    path: "/en/karrier/allas/:slug().j-:id()/:hash()",
    meta: _91hash_93yEIL0g1oUaGGwyYyCyruQAaCPvvECcpPPCe_k_23ijoMeta || {},
    component: () => import("/home/node/app/shop/app/pages/karrier/allas/[slug].j-[id]/[hash].vue")
  },
  {
    name: "karrier-ajanlatok-applicationGuid___hu",
    path: "/karrier/ajanlatok/:applicationGuid()",
    meta: _91applicationGuid_93EEhH8J4OYnr8WmW_d87zwgGle2fWQbe8mFuaghk9fxMMeta || {},
    component: () => import("/home/node/app/shop/app/pages/karrier/ajanlatok/[applicationGuid].vue")
  },
  {
    name: "karrier-ajanlatok-applicationGuid___en",
    path: "/en/karrier/ajanlatok/:applicationGuid()",
    meta: _91applicationGuid_93EEhH8J4OYnr8WmW_d87zwgGle2fWQbe8mFuaghk9fxMMeta || {},
    component: () => import("/home/node/app/shop/app/pages/karrier/ajanlatok/[applicationGuid].vue")
  },
  {
    name: "karrier-allas-slug.j-id___hu",
    path: "/karrier/allas/:slug().j-:id()",
    meta: indexuiqKSzpiaJWoEODXqRCJ8CHArU9uIKRxPEwLph8oy9IMeta || {},
    component: () => import("/home/node/app/shop/app/pages/karrier/allas/[slug].j-[id]/index.vue")
  },
  {
    name: "karrier-allas-slug.j-id___en",
    path: "/en/karrier/allas/:slug().j-:id()",
    meta: indexuiqKSzpiaJWoEODXqRCJ8CHArU9uIKRxPEwLph8oy9IMeta || {},
    component: () => import("/home/node/app/shop/app/pages/karrier/allas/[slug].j-[id]/index.vue")
  },
  {
    name: "shop-checkout-success-orderIdent___hu",
    path: "/shop/checkout-success/:orderIdent()",
    meta: _91orderIdent_937QyNdkUQ1dE4EjkXrEyutoQNdtN9Y7LFoo6Yf6WEZ2oMeta || {},
    component: () => import("/home/node/app/shop/app/pages/shop/checkout-success/[orderIdent].vue")
  },
  {
    name: "shop-checkout-success-orderIdent___en",
    path: "/en/shop/checkout-success/:orderIdent()",
    meta: _91orderIdent_937QyNdkUQ1dE4EjkXrEyutoQNdtN9Y7LFoo6Yf6WEZ2oMeta || {},
    component: () => import("/home/node/app/shop/app/pages/shop/checkout-success/[orderIdent].vue")
  },
  {
    name: "shop-checkout-type___hu",
    path: "/shop/checkout/:type()",
    meta: _91type_93F_QyMU_D09KY1JiMkrkx66EyzIJC1ST51KKfzAJRypAMeta || {},
    component: () => import("/home/node/app/shop/app/pages/shop/checkout/[type].vue")
  },
  {
    name: "shop-checkout-type___en",
    path: "/en/shop/checkout/:type()",
    meta: _91type_93F_QyMU_D09KY1JiMkrkx66EyzIJC1ST51KKfzAJRypAMeta || {},
    component: () => import("/home/node/app/shop/app/pages/shop/checkout/[type].vue")
  },
  {
    name: "shop-list-list_name___hu",
    path: "/shop/list/:list_name()",
    meta: _91list_name_93qjBtqlGTA6kb9PsSnt30l4Ly6IxQ8CdmwXihEM6SaywMeta || {},
    component: () => import("/home/node/app/shop/app/pages/shop/list/[list_name].vue")
  },
  {
    name: "shop-list-list_name___en",
    path: "/en/shop/list/:list_name()",
    meta: _91list_name_93qjBtqlGTA6kb9PsSnt30l4Ly6IxQ8CdmwXihEM6SaywMeta || {},
    component: () => import("/home/node/app/shop/app/pages/shop/list/[list_name].vue")
  },
  {
    name: "cetelem-back___hu",
    path: "/cetelem/back",
    component: () => import("/home/node/app/shop/app/pages/cetelem/back/index.vue")
  },
  {
    name: "cetelem-back___en",
    path: "/en/cetelem/back",
    component: () => import("/home/node/app/shop/app/pages/cetelem/back/index.vue")
  },
  {
    name: "karrier-hirek___hu",
    path: "/karrier/hirek",
    meta: indexwnXmKY4GSWJPF_UjxAJxz9SGtR1HSQu6GX3NQavEx_oMeta || {},
    component: () => import("/home/node/app/shop/app/pages/karrier/hirek/index.vue")
  },
  {
    name: "karrier-hirek___en",
    path: "/en/karrier/hirek",
    meta: indexwnXmKY4GSWJPF_UjxAJxz9SGtR1HSQu6GX3NQavEx_oMeta || {},
    component: () => import("/home/node/app/shop/app/pages/karrier/hirek/index.vue")
  },
  {
    name: "login-Salesforce___hu",
    path: "/login/Salesforce",
    meta: SalesforceDHeWUHhjl_w2shTKFMafpchVNfamZKM_qsKS1SuAjHQMeta || {},
    component: () => import("/home/node/app/shop/app/pages/login/Salesforce.vue")
  },
  {
    name: "login-Salesforce___en",
    path: "/en/login/Salesforce",
    meta: SalesforceDHeWUHhjl_w2shTKFMafpchVNfamZKM_qsKS1SuAjHQMeta || {},
    component: () => import("/home/node/app/shop/app/pages/login/Salesforce.vue")
  },
  {
    name: "loyalty-program-faq___hu",
    path: "/bizalomkartya/gyik",
    meta: indexGlRh3_FJGeHYrQMbVnQQ5WDoBf_t8sR_iIv54DP4aWMMeta || {},
    component: () => import("/home/node/app/shop/app/pages/loyalty-program/faq/index.vue")
  },
  {
    name: "loyalty-program-faq___en",
    path: "/en/loyalty-program/faq",
    meta: indexGlRh3_FJGeHYrQMbVnQQ5WDoBf_t8sR_iIv54DP4aWMMeta || {},
    component: () => import("/home/node/app/shop/app/pages/loyalty-program/faq/index.vue")
  },
  {
    name: "otp-back___hu",
    path: "/otp/back",
    component: () => import("/home/node/app/shop/app/pages/otp/back/index.vue")
  },
  {
    name: "otp-back___en",
    path: "/en/otp/back",
    component: () => import("/home/node/app/shop/app/pages/otp/back/index.vue")
  },
  {
    name: "petrol-faq___hu",
    path: "/benzinkutak/gyik",
    meta: indexNLYSWNur2_Fo7fxCcZ8QxzcNsBsdVXmtjicf9INbnh0Meta || {},
    component: () => import("/home/node/app/shop/app/pages/petrol/faq/index.vue")
  },
  {
    name: "petrol-faq___en",
    path: "/en/petrol/faq",
    meta: indexNLYSWNur2_Fo7fxCcZ8QxzcNsBsdVXmtjicf9INbnh0Meta || {},
    component: () => import("/home/node/app/shop/app/pages/petrol/faq/index.vue")
  },
  {
    name: "shop-basket___hu",
    path: "/shop/kosar",
    meta: indexf8MFGYY98zUistBLtQ1uG57AaxcH9r04_cEkGn_DoBYMeta || {},
    component: () => import("/home/node/app/shop/app/pages/shop/basket/index.vue")
  },
  {
    name: "shop-basket___en",
    path: "/en/shop/basket",
    meta: indexf8MFGYY98zUistBLtQ1uG57AaxcH9r04_cEkGn_DoBYMeta || {},
    component: () => import("/home/node/app/shop/app/pages/shop/basket/index.vue")
  },
  {
    name: "shop-compare___hu",
    path: "/shop/termek-osszehasonlitas",
    component: () => import("/home/node/app/shop/app/pages/shop/compare/index.vue")
  },
  {
    name: "shop-compare___en",
    path: "/en/shop/compare",
    component: () => import("/home/node/app/shop/app/pages/shop/compare/index.vue")
  },
  {
    name: "shop-loyalty-offers___hu",
    path: "/shop/bizalomkartyas-ajanlatok",
    meta: indexZIiN52xkEf7SVkhFrDWOgouQq_J7YfStUAiRe3E8Jt8Meta || {},
    component: () => import("/home/node/app/shop/app/pages/shop/loyalty-offers/index.vue")
  },
  {
    name: "shop-loyalty-offers___en",
    path: "/en/shop/loyalty-offers",
    meta: indexZIiN52xkEf7SVkhFrDWOgouQq_J7YfStUAiRe3E8Jt8Meta || {},
    component: () => import("/home/node/app/shop/app/pages/shop/loyalty-offers/index.vue")
  },
  {
    name: "simple-back___hu",
    path: "/simple/back",
    component: () => import("/home/node/app/shop/app/pages/simple/back/index.vue")
  },
  {
    name: "simple-back___en",
    path: "/en/simple/back",
    component: () => import("/home/node/app/shop/app/pages/simple/back/index.vue")
  },
  {
    name: "test-recon___hu",
    path: "/test/recon",
    component: () => import("/home/node/app/shop/app/pages/test/recon/index.vue")
  },
  {
    name: "test-recon___en",
    path: "/en/test/recon",
    component: () => import("/home/node/app/shop/app/pages/test/recon/index.vue")
  },
  {
    name: "news-type-slug___hu",
    path: "/hirek/:type()/:slug()",
    meta: _91slug_93gEdkP__NKFkKyLcB0TwIU4DvQbsVxAaOToKUhAQfI1IMeta || {},
    component: () => import("/home/node/app/shop/app/pages/news/[type]/[slug].vue")
  },
  {
    name: "news-type-slug___en",
    path: "/en/news/:type()/:slug()",
    meta: _91slug_93gEdkP__NKFkKyLcB0TwIU4DvQbsVxAaOToKUhAQfI1IMeta || {},
    component: () => import("/home/node/app/shop/app/pages/news/[type]/[slug].vue")
  },
  {
    name: "activate_registration-hash___hu",
    path: "/activate_registration/:hash()",
    component: () => import("/home/node/app/shop/app/pages/activate_registration/[hash].vue")
  },
  {
    name: "activate_registration-hash___en",
    path: "/en/activate_registration/:hash()",
    component: () => import("/home/node/app/shop/app/pages/activate_registration/[hash].vue")
  },
  {
    name: "career_password_change-hash___hu",
    path: "/career_password_change/:hash()",
    component: () => import("/home/node/app/shop/app/pages/career_password_change/[hash].vue")
  },
  {
    name: "career_password_change-hash___en",
    path: "/en/career_password_change/:hash()",
    component: () => import("/home/node/app/shop/app/pages/career_password_change/[hash].vue")
  },
  {
    name: "content-id___hu",
    path: "/content/:id()",
    meta: _91id_93QmrYkr8AW4uQyxwrgTJ_IwuyY_G12cg1nvWFp8lGTdwMeta || {},
    component: () => import("/home/node/app/shop/app/pages/content/[id].vue")
  },
  {
    name: "content-id___en",
    path: "/en/content/:id()",
    meta: _91id_93QmrYkr8AW4uQyxwrgTJ_IwuyY_G12cg1nvWFp8lGTdwMeta || {},
    component: () => import("/home/node/app/shop/app/pages/content/[id].vue")
  },
  {
    name: "gift-card-order-success-orderIdent___hu",
    path: "/gift-card-order-success/:orderIdent()",
    meta: _91orderIdent_93v5UyRcxdyOivodbDgYOD8_2TC1m8IYmn8L5SDhBm8lUMeta || {},
    component: () => import("/home/node/app/shop/app/pages/gift-card-order-success/[orderIdent].vue")
  },
  {
    name: "gift-card-order-success-orderIdent___en",
    path: "/en/gift-card-order-success/:orderIdent()",
    meta: _91orderIdent_93v5UyRcxdyOivodbDgYOD8_2TC1m8IYmn8L5SDhBm8lUMeta || {},
    component: () => import("/home/node/app/shop/app/pages/gift-card-order-success/[orderIdent].vue")
  },
  {
    name: "password_change-hash___hu",
    path: "/password_change/:hash()",
    component: () => import("/home/node/app/shop/app/pages/password_change/[hash].vue")
  },
  {
    name: "password_change-hash___en",
    path: "/en/password_change/:hash()",
    component: () => import("/home/node/app/shop/app/pages/password_change/[hash].vue")
  },
  {
    name: "petrol-slug___hu",
    path: "/benzinkutak/:slug()",
    meta: _91slug_939y55sL0YNVIb_p9MqSMu2MhktqSyW6lwxft2Kv162voMeta || {},
    component: () => import("/home/node/app/shop/app/pages/petrol/[slug].vue")
  },
  {
    name: "petrol-slug___en",
    path: "/en/petrol/:slug()",
    meta: _91slug_939y55sL0YNVIb_p9MqSMu2MhktqSyW6lwxft2Kv162voMeta || {},
    component: () => import("/home/node/app/shop/app/pages/petrol/[slug].vue")
  },
  {
    name: "product-list-id___hu",
    path: "/product-list/:id()",
    component: () => import("/home/node/app/shop/app/pages/product-list/[id].vue")
  },
  {
    name: "product-list-id___en",
    path: "/en/product-list/:id()",
    component: () => import("/home/node/app/shop/app/pages/product-list/[id].vue")
  },
  {
    name: "product-id___hu",
    path: "/product/:id()",
    component: () => import("/home/node/app/shop/app/pages/product/[id].vue")
  },
  {
    name: "product-id___en",
    path: "/en/product/:id()",
    component: () => import("/home/node/app/shop/app/pages/product/[id].vue")
  },
  {
    name: "stores-slug___hu",
    path: "/aruhazak/:slug()",
    meta: _91slug_93iQVXuwL8ayKAAUYpHSb0IA0ZwHU0UWwM_ZMHFQ2NRy8Meta || {},
    component: () => import("/home/node/app/shop/app/pages/stores/[slug].vue")
  },
  {
    name: "stores-slug___en",
    path: "/en/stores/:slug()",
    meta: _91slug_93iQVXuwL8ayKAAUYpHSb0IA0ZwHU0UWwM_ZMHFQ2NRy8Meta || {},
    component: () => import("/home/node/app/shop/app/pages/stores/[slug].vue")
  },
  {
    name: "user_email_update-hash___hu",
    path: "/user_email_update/:hash()",
    component: () => import("/home/node/app/shop/app/pages/user_email_update/[hash].vue")
  },
  {
    name: "user_email_update-hash___en",
    path: "/en/user_email_update/:hash()",
    component: () => import("/home/node/app/shop/app/pages/user_email_update/[hash].vue")
  },
  {
    name: "ajandekkartya-igenyles___hu",
    path: "/ajandekkartya-igenyles",
    meta: indexNkRI716QfI18jgkUfv5cVtyXIEn_TDft9unD3kh18MAMeta || {},
    component: () => import("/home/node/app/shop/app/pages/ajandekkartya-igenyles/index.vue")
  },
  {
    name: "ajandekkartya-igenyles___en",
    path: "/en/ajandekkartya-igenyles",
    meta: indexNkRI716QfI18jgkUfv5cVtyXIEn_TDft9unD3kh18MAMeta || {},
    component: () => import("/home/node/app/shop/app/pages/ajandekkartya-igenyles/index.vue")
  },
  {
    name: "catalog___hu",
    path: "/katalogusok",
    meta: index2Yxux4s_smuRhUbW4zZ4HrM9tZp7MTjY_Se01Q_FQUMMeta || {},
    component: () => import("/home/node/app/shop/app/pages/catalog/index.vue")
  },
  {
    name: "catalog___en",
    path: "/en/catalog",
    meta: index2Yxux4s_smuRhUbW4zZ4HrM9tZp7MTjY_Se01Q_FQUMMeta || {},
    component: () => import("/home/node/app/shop/app/pages/catalog/index.vue")
  },
  {
    name: "csr___hu",
    path: "/csr",
    meta: indexz79kCq2TkpT5bZuwiwhOMDKGPuQsiCxVwdWwoldF_BYMeta || {},
    component: () => import("/home/node/app/shop/app/pages/csr/index.vue")
  },
  {
    name: "csr___en",
    path: "/en/csr",
    meta: indexz79kCq2TkpT5bZuwiwhOMDKGPuQsiCxVwdWwoldF_BYMeta || {},
    component: () => import("/home/node/app/shop/app/pages/csr/index.vue")
  },
  {
    name: "faq___hu",
    path: "/gyik",
    meta: indexStrdWRNtV5jJ1wYajuuXB_iCJwCGgMjVXQvfBmgG3_kMeta || {},
    component: () => import("/home/node/app/shop/app/pages/faq/index.vue")
  },
  {
    name: "faq___en",
    path: "/en/faq",
    meta: indexStrdWRNtV5jJ1wYajuuXB_iCJwCGgMjVXQvfBmgG3_kMeta || {},
    component: () => import("/home/node/app/shop/app/pages/faq/index.vue")
  },
  {
    name: "food-delivery-map___hu",
    path: "/kiszallitasi-teruleteink",
    component: () => import("/home/node/app/shop/app/pages/food-delivery-map/index.vue")
  },
  {
    name: "food-delivery-map___en",
    path: "/en/food-delivery-map",
    component: () => import("/home/node/app/shop/app/pages/food-delivery-map/index.vue")
  },
  {
    name: "forgotten-password___hu",
    path: "/forgotten-password",
    component: () => import("/home/node/app/shop/app/pages/forgotten-password/index.vue")
  },
  {
    name: "forgotten-password___en",
    path: "/en/forgotten-password",
    component: () => import("/home/node/app/shop/app/pages/forgotten-password/index.vue")
  },
  {
    name: "inspirations___hu",
    path: "/inspiraciok",
    meta: index2LPWuPSJF9gAF4ibQoRq5L2HhtgByI3B0eeXqVCe6qIMeta || {},
    component: () => import("/home/node/app/shop/app/pages/inspirations/index.vue")
  },
  {
    name: "inspirations___en",
    path: "/en/inspirations",
    meta: index2LPWuPSJF9gAF4ibQoRq5L2HhtgByI3B0eeXqVCe6qIMeta || {},
    component: () => import("/home/node/app/shop/app/pages/inspirations/index.vue")
  },
  {
    name: "news___hu",
    path: "/hirek",
    meta: index1ezYsO6zNgz0X5y9EmmVV_aEoWpsQhEY4UHTF_xAjzoMeta || {},
    component: () => import("/home/node/app/shop/app/pages/news/index.vue")
  },
  {
    name: "news___en",
    path: "/en/news",
    meta: index1ezYsO6zNgz0X5y9EmmVV_aEoWpsQhEY4UHTF_xAjzoMeta || {},
    component: () => import("/home/node/app/shop/app/pages/news/index.vue")
  },
  {
    name: "payment-redirect___hu",
    path: "/payment-redirect",
    component: () => import("/home/node/app/shop/app/pages/payment-redirect/index.vue")
  },
  {
    name: "payment-redirect___en",
    path: "/en/payment-redirect",
    component: () => import("/home/node/app/shop/app/pages/payment-redirect/index.vue")
  },
  {
    name: "press___hu",
    path: "/sajtokozlemenyek",
    meta: indexVTY2UoKdOlWzWMoBJ2S4JZ5nZIniUUQJWOgOX3t9RpwMeta || {},
    component: () => import("/home/node/app/shop/app/pages/press/index.vue")
  },
  {
    name: "press___en",
    path: "/en/press",
    meta: indexVTY2UoKdOlWzWMoBJ2S4JZ5nZIniUUQJWOgOX3t9RpwMeta || {},
    component: () => import("/home/node/app/shop/app/pages/press/index.vue")
  },
  {
    name: "prize-game___hu",
    path: "/nyeremenyjatekok",
    meta: indexZQ8IH_GoF_dQnT8gfxvm4MFo_0_UXtRfD_XsO7kN2oIMeta || {},
    component: () => import("/home/node/app/shop/app/pages/prize-game/index.vue")
  },
  {
    name: "prize-game___en",
    path: "/en/prize-game",
    meta: indexZQ8IH_GoF_dQnT8gfxvm4MFo_0_UXtRfD_XsO7kN2oIMeta || {},
    component: () => import("/home/node/app/shop/app/pages/prize-game/index.vue")
  },
  {
    name: "safety-data-sheet___hu",
    path: "/biztonsagi-adatlapok",
    meta: index8FM2v9IdOH7DI5ttPfFGXg6iZMvgI_IstrMOtc3fHbgMeta || {},
    component: () => import("/home/node/app/shop/app/pages/safety-data-sheet/index.vue")
  },
  {
    name: "safety-data-sheet___en",
    path: "/en/safety-data-sheet",
    meta: index8FM2v9IdOH7DI5ttPfFGXg6iZMvgI_IstrMOtc3fHbgMeta || {},
    component: () => import("/home/node/app/shop/app/pages/safety-data-sheet/index.vue")
  },
  {
    name: "shop___hu",
    path: "/shop",
    meta: indexgMcUrF09WinEJU8FBiRv63JZUiPpcbxrARZLLn76ktYMeta || {},
    component: () => import("/home/node/app/shop/app/pages/shop/index.vue")
  },
  {
    name: "shop___en",
    path: "/en/shop",
    meta: indexgMcUrF09WinEJU8FBiRv63JZUiPpcbxrARZLLn76ktYMeta || {},
    component: () => import("/home/node/app/shop/app/pages/shop/index.vue")
  },
  {
    name: "stores___hu",
    path: "/aruhazak",
    meta: indexy2rZxuUoEL0zG7joIoZ1h6BRzpl0sEhfo8x_PCPG6gsMeta || {},
    component: () => import("/home/node/app/shop/app/pages/stores/index.vue")
  },
  {
    name: "stores___en",
    path: "/en/stores",
    meta: indexy2rZxuUoEL0zG7joIoZ1h6BRzpl0sEhfo8x_PCPG6gsMeta || {},
    component: () => import("/home/node/app/shop/app/pages/stores/index.vue")
  },
  {
    name: "unsubscribe___hu",
    path: "/hirlevel-leiratkozas",
    component: () => import("/home/node/app/shop/app/pages/unsubscribe/index.vue")
  },
  {
    name: "unsubscribe___en",
    path: "/en/unsubscribe",
    component: () => import("/home/node/app/shop/app/pages/unsubscribe/index.vue")
  },
  {
    name: "slug___hu",
    path: "/:slug(.*)*",
    meta: _91_46_46_46slug_93mA4XAdFsBtxO1eJKcnDotAmGqzTBJBPjaC2Cv2ah5u8Meta || {},
    component: () => import("/home/node/app/shop/app/pages/[...slug].vue")
  },
  {
    name: "slug___en",
    path: "/en/:slug(.*)*",
    meta: _91_46_46_46slug_93mA4XAdFsBtxO1eJKcnDotAmGqzTBJBPjaC2Cv2ah5u8Meta || {},
    component: () => import("/home/node/app/shop/app/pages/[...slug].vue")
  },
  {
    name: "index___hu",
    path: "/",
    meta: index_nPP1dj__PIFTxc6OCIouqT4ytO_ccsYURnU_7_rCl0Meta || {},
    component: () => import("/home/node/app/shop/app/pages/index.vue")
  },
  {
    name: "index___en",
    path: "/en",
    meta: index_nPP1dj__PIFTxc6OCIouqT4ytO_ccsYURnU_7_rCl0Meta || {},
    component: () => import("/home/node/app/shop/app/pages/index.vue")
  },
  {
    name: component_45stubEfxyiN_x6Y8wD0QhzHCU33g2TBS2HdmakVxbMdrPi7gMeta?.name,
    path: "/sitemap.xml",
    component: component_45stubEfxyiN_x6Y8wD0QhzHCU33g2TBS2HdmakVxbMdrPi7g
  },
  {
    name: component_45stubEfxyiN_x6Y8wD0QhzHCU33g2TBS2HdmakVxbMdrPi7gMeta?.name,
    path: "/en/sitemap.xml",
    component: component_45stubEfxyiN_x6Y8wD0QhzHCU33g2TBS2HdmakVxbMdrPi7g
  }
]